const headers = (contentType = 'application/x-www-form-urlencoded; charset=UTF-8') => {
    return new Headers({
        'Content-Type': contentType,
        'X-Requested-With': 'XMLHttpRequest'
    })
}

/** Utility for making CORS GET REST requests easier */
export const get = (url, contentType) => {
    return fetch(url, {
        method: 'GET',
        credentials: 'include',
        headers: headers(contentType)
    })
}

/** Utility for making POST REST requests easier */
export const post = (url, body, contentType = 'application/json') => {
    return fetch(url, {
        method: 'POST', 
        credentials: 'include',
        headers: headers(contentType),
        body: JSON.stringify(body)
    })
}

/** Utility for making POST REST requests easier */
export const put = (url, body, contentType = 'application/json') => {
    return fetch(url, {
        method: 'PUT', 
        credentials: 'include',
        headers: headers(contentType),
        body: JSON.stringify(body)
    })
}

/** Utility for making POST REST requests easier. ('delete' is a reserved word in JS, so it's deleteReq instead - rrogers) */
export const deleteReq = (url, body, contentType = 'application/json') => {
    return fetch(url, {
        method: 'DELETE', 
        credentials: 'include',
        headers: headers(contentType),
        body: JSON.stringify(body)
    })
    
}

export const checkResponse = uri => response => {
    if (response.status !== 200)
        console.warn(`Error Reaching Endpoint [${uri}]`, response)

    return response.json()
}